module.exports = __webpack_public_path__ + "img/William Beauty Salon.d85f3385.svg";